"use client";

import * as React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import { DirectionProvider, ThemeProvider, Toaster } from "@gerama/ui";
import { makeQueryClient } from "@/lib/query-client";
import { LoginModal } from "@/features/auth/login-modal";

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = React.useState(makeQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <NuqsAdapter>
        <DirectionProvider dir="rtl">
          <ThemeProvider>
            {children}
            <React.Suspense fallback={null}>
              <LoginModal />
            </React.Suspense>
            <Toaster />
          </ThemeProvider>
        </DirectionProvider>
      </NuqsAdapter>
    </QueryClientProvider>
  );
}
